import ProductPrice from './ProductPrice';
export { default as InlinePrice } from './InlinePrice';
export { ProductPrice };
export default ProductPrice;